/* global AFRAME */
import React, { useRef, useState, useEffect } from "react"

import { isMobile } from "react-device-detect"
import "aframe"

import { applyZoom } from "./functions/zoom"

import HorizontalScrollingMenu from "./HorizontalScrollingMenu"
import Sub from "./Sub"
import Navbar from "./Navbar"
import MainFrame from "./frames/MainFrame"

import SerieSigma from "./frames/SerieSigma"
import Sigma40 from "./frames/Sigma40"
import Sigma36 from "./frames/Sigma36"
import Sigma34 from "./frames/Sigma34"

import Caracteristicas from "./frames/Caracteristicas"
import Camilla from "./frames/Camilla"

import SistemaEstandarBIBS from "./frames/SistemaEstandarBIBS"
import SistemaUndercarriage from "./frames/SistemaUndercarriage"
import SistemaAirBreak from "./frames/SistemaAirBreak"
import SistemaElite from "./frames/SistemaElite"
import PerryEliteEMR from "./frames/PerryEliteEMR"

import Transporte from "./frames/Transporte"
import GestionAduanas from "./frames/GestionAduanas"

import Instalacion from "./frames/Instalacion"
import Mantenimiento from "./frames/Mantenimiento"

import DatosEconomicos from "./frames/DatosEconomicos"
import SeleccionUbicacion from "./frames/SeleccionUbicacion"
import Medico from "./frames/Medico"
import Diseno from "./frames/Diseno"
import MedidasSeguridad from "./frames/MedidasSeguridad"
import Normativa from "./frames/Normativa"

import Formacion from "./frames/Formacion"

import Accesorios from "./frames/Accesorios"

import "./main.css"

export default function AFrameScene() {
  const scene_element = useRef(null)
  const camera_element = useRef(null)
  const [cameraRotation, setCameraRotation] = useState([0, 0, 0])
  const [previousIndex, setPreviousIndex] = useState(0)
  const [activeButton, setActiveButton] = useState(null)
  const [resetContent, setResetContent] = useState(false)
  const [isMenuVisible, setIsMenuVisible] = useState(true)
  const [assetsLoaded, setAssetsLoaded] = useState(false)
  const [isArrowVisible, setIsArrowVisible] = useState(true)

  const [isFrame, setIsFrame] = useState(false)

  const [frameVisibility, setFrameVisibility] = useState(false)
  const [currentChild, setCurrentChild] = useState(null)

  const handleCloseFrame = () => {
    setFrameVisibility(false)
  }

  const handleShowFrame = () => {
    setFrameVisibility(true)
  }

  const commonOnClick = () => {
    setFrameVisibility(true)
    setIsMenuVisible(false)
    setIsArrowVisible(false)
    setIsFrame(true)
  }
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [items, setItems] = useState([
    {
      text: "CONOCE LA SERIE SIGMA",
      onClick: () => {
        setCurrentChild(SerieSigma)
        commonOnClick()
      },
    },
    {
      text: "Sigma 40",
      onClick: () => {
        setCurrentChild(Sigma40)
        commonOnClick()
      },
    },
    {
      text: "Sigma 36",
      onClick: () => {
        setCurrentChild(Sigma36)
        commonOnClick()
      },
    },
    {
      text: "Sigma 34",
      onClick: () => {
        setCurrentChild(Sigma34)
        commonOnClick()
      },
    },
  ])
  const toggleArrowVisibility = () => {
    setIsArrowVisible(!isArrowVisible)
  }
  useEffect(() => {
    if (isMobile) {
      // Desactivar la orientación del dispositivo
      window.addEventListener(
        "deviceorientation",
        function (event) {
          event.preventDefault()
        },
        true
      )
    }
  }, [])

  useEffect(() => {
    document.querySelector("a-assets").addEventListener("loaded", function () {
      setAssetsLoaded(true)
    })
  }, [])

  useEffect(() => {
    applyZoom(scene_element.current)
    const image = new Image()
    image.src = "/images/fondo.webp"
    image.onload = handleTextureLoaded
  }, [])

  // Function to execute when the texture has loaded.
  const handleTextureLoaded = () => {
    const sky = scene_element.current.querySelector("a-sky")
    if (sky) {
      sky.setAttribute("animation", {
        property: "material.opacity",
        to: "1",
        dur: "2000",
        easing: "easeInOutSine",
      })
    }
  }

  // Function to handle button clicks.
  const handleButtonClick = (index) => {
    setActiveButton(index)
    if (index === 8 || index === 9) {
      setIsMenuVisible(false)
      setIsArrowVisible(false)
      setIsFrame(true)
      setFrameVisibility(false)
    } else {
      setIsMenuVisible(true)
      setIsArrowVisible(true)
      setIsFrame(false)
    }
  }

  // Function to handle a change in the active item in the scrolling menu.
  const handleItemChange = (index) => {
    const rotationStep = 45
    let rotationDiff
    let newItems
    let newChild
    switch (index) {
      case 0:
        newItems = [
          {
            text: "CONOCE LA SERIE SIGMA",
            onClick: () => {
              commonOnClick()
              setCurrentChild(SerieSigma)
            },
          },
          {
            text: "Sigma 40",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Sigma40)
            },
          },
          {
            text: "Sigma 36",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Sigma36)
            },
          },
          {
            text: "Sigma 34",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Sigma34)
            },
          },
        ]

        break
      case 1:
        newItems = [
          {
            text: "Características de las cámaras",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Caracteristicas)
            },
          },
          {
            text: "Camilla Stryker",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Camilla)
            },
          },
        ]
        break
      case 2:
        newItems = [
          {
            text: "Sistema Estándar A / BIBS B",
            onClick: () => {
              commonOnClick()
              setCurrentChild(SistemaEstandarBIBS)
            },
          },
          {
            text: "Sistema Undercarriage",
            onClick: () => {
              commonOnClick()
              setCurrentChild(SistemaUndercarriage)
            },
          },
          {
            text: "Sistema Air Break",
            onClick: () => {
              commonOnClick()
              setCurrentChild(SistemaAirBreak)
            },
          },
          {
            text: "Sistema Elite",
            onClick: () => {
              commonOnClick()
              setCurrentChild(SistemaElite)
            },
          },
          {
            text: "Perry Elite EMR",
            onClick: () => {
              commonOnClick()
              setCurrentChild(PerryEliteEMR)
            },
          },
        ]
        break
      case 3:
        newItems = [
          {
            text: "Transporte",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Transporte)
            },
          },
          {
            text: "Gestión de aduanas",
            onClick: () => {
              commonOnClick()
              setCurrentChild(GestionAduanas)
            },
          },
        ]
        break
      case 4:
        newItems = [
          {
            text: "Instalación",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Instalacion)
            },
          },
          {
            text: "Mantenimiento",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Mantenimiento)
            },
          },
        ]
        break
      case 5:
        newItems = [
          {
            text: "Datos económicos",
            onClick: () => {
              commonOnClick()
              setCurrentChild(DatosEconomicos)
            },
          },
          {
            text: "Selección de ubicación",
            onClick: () => {
              commonOnClick()
              setCurrentChild(SeleccionUbicacion)
            },
          },
          {
            text: "Médico",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Medico)
            },
          },
          {
            text: "Diseño",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Diseno)
            },
          },
          {
            text: "Medidas de seguridad",
            onClick: () => {
              commonOnClick()
              setCurrentChild(MedidasSeguridad)
            },
          },
          {
            text: "Normativa",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Normativa)
            },
          },
        ]
        break
      case 6:
        newItems = [
          {
            text: "Formación con OXANA",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Formacion)
            },
          },
        ]
        break
      case 7:
        newItems = [
          {
            text: "Accesorios",
            onClick: () => {
              commonOnClick()
              setCurrentChild(Accesorios)
            },
          },
        ]
        break
      // ... otros casos
      default:
        newItems = []
    }
    // Actualiza el estado de 'items'
    setItems(newItems)
    const items = [
      {
        text: "Nuevo elemento",
        onClick: () => console.log("Nuevo elemento clickeado"),
      },
      // ... otros elementos
    ]

    if (previousIndex === 0 && index === 7) {
      rotationDiff = rotationStep
    } else if (previousIndex === 7 && index === 0) {
      rotationDiff = -rotationStep
    } else {
      rotationDiff = (previousIndex - index) * rotationStep
    }

    const newRotation = cameraRotation[1] + rotationDiff
    const newRotationX = 0
    const newRotationY = newRotation

    const handleAnimationComplete = function () {
      this.components["look-controls"].pitchObject.rotation.x =
        AFRAME.THREE.MathUtils.degToRad(newRotationX)
      this.components["look-controls"].yawObject.rotation.y =
        AFRAME.THREE.MathUtils.degToRad(newRotationY)

      // Remover el listener del evento para que no se ejecute nuevamente
      camera_element.current.removeEventListener(
        "animationcomplete",
        handleAnimationComplete
      )
    }

    if (camera_element.current) {
      camera_element.current.setAttribute("animation", {
        property: "rotation",
        to: `0 ${newRotation} 0`,
        dur: "800",
        easing: "easeInOutQuad",
      })

      // Agregar el listener del evento
      camera_element.current.addEventListener(
        "animationcomplete",
        handleAnimationComplete
      )

      setCameraRotation([0, newRotation, 0])
      setPreviousIndex(index)
    }

    setActiveButton(null)
    setResetContent(true)
    setIsMenuVisible(true)
    setSelectedIndex(index)
  }

  // Function to reset the content.
  const contentReset = () => {
    setResetContent(false)
  }

  // Function to show the menu when the "Explore!" button is clicked.
  const handleShowMenuClick = () => {
    setIsMenuVisible(true)
    setActiveButton(null)
    setResetContent(true)
    setIsArrowVisible(true)
    setFrameVisibility(false)
    setIsFrame(false)
  }

  // Render the component.
  return (
    <div>
      <div className={isMobile ? "maincont2" : "maincont"}></div>
      <div className={isMenuVisible ? "" : "menu-hidden"}>
        <a-scene
          ref={scene_element}
          vr-mode-ui="enabled: false"
          device-orientation-permission-ui="enabled: false"
          renderer="antialias: true"
          environment="preset: forest; skyType: gradient;"
          antialias="true;"
          colorManagement="true;"
        >
          <a-assets>
            <a-asset-item id="texto1" src="/modelos/texto1.glb"></a-asset-item>
            <a-asset-item id="texto2" src="/modelos/texto2.glb"></a-asset-item>
            <a-asset-item id="texto3" src="/modelos/texto3.glb"></a-asset-item>
            <a-asset-item id="texto4" src="/modelos/texto4.glb"></a-asset-item>
            <a-asset-item id="texto5" src="/modelos/texto5.glb"></a-asset-item>
            <a-asset-item
              id="caracteristicas"
              src="/modelos/caracteristicas.glb"
            ></a-asset-item>
          </a-assets>

          <a-entity cursor="rayOrigin:mouse"></a-entity>
          <a-sky
            color="#F1F8FF"
            src="/images/fondo.webp"
            material="opacity: 0;"
          ></a-sky>
          <a-camera
            ref={camera_element}
            look-controls="gyroEnabled: false; magicWindowTrackingEnabled: false; reverseMouseDrag: true"
            touch-controls="enabled: true; lookEnabled: true"
            wasd-controls="acceleration:0"
            position="0 40 0"
            fov={isMobile ? "80" : "50"}
          ></a-camera>
          <a-entity
            gltf-model="#textomodelo"
            scale="10"
            position="0 40 20"
          ></a-entity>
        </a-scene>
        <HorizontalScrollingMenu
          onActiveItemChange={handleItemChange}
          isVisible={isMenuVisible}
        />
        <Navbar
          onButtonClick={handleButtonClick}
          activeButton={activeButton}
          resetContent={resetContent}
          onContentReset={contentReset}
        />
        <Sub
          isVisible={isMenuVisible}
          items={items}
          isArrowVisible={isArrowVisible}
          selectedIndex={selectedIndex}
          isFrame={isFrame}
        />
        <MainFrame isVisible={frameVisibility} onClose={handleCloseFrame}>
          {currentChild}
        </MainFrame>
        <button className="show-menu-btn" onClick={handleShowMenuClick}>
          ¡Explorar!
        </button>
      </div>
    </div>
  )
}
